import { render } from "./user-view-page.vue?vue&type=template&id=28cf5b9c"
import script from "./user-view-page.vue?vue&type=script&lang=js"
export * from "./user-view-page.vue?vue&type=script&lang=js"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__